// ---------------------------------------------------------------
// Product factory for Hyundai HD120 series
// ---------------------------------------------------------------
const createHD120Product = (data: any) => ({
  ...data,
  price: 0,
  status: '재고있음',
  category: 'HYUNDAI HD120',
  colors: data.colors || ['#808080'],
  features: [
    { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
    { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
    { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
  ],
  craftStory: {
    // Added an underscore between the id and the word "craft" to avoid malformed URLs
    image: `https://public.readdy.ai/ai/img_res/90d9aafa5f90b4e2cb9ebd506fbc2063.jpg${data.id}_craft&orientation=landscape`,
    story: `HD120의 ${data.description}입니다.`,
    details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
  },
});

// ---------------------------------------------------------------
// MIG series (HD120 신형)
// ---------------------------------------------------------------
const migProducts = [
  createHD120Product({
    id: 'MIG001',
    name: 'MIG001',
    description: 'HEAD LAMP',
    subcategory: '램프',
    partNumber: '92101-5M000 L / 92102-5M000 R',
    fullDescription:
      '현대 HD120 MIG 시리즈에 호환되는 헤드 램프입니다. 품번 92101-5M000 L / 92102-5M000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20head%20lamp%20headlight%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig001main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20headlight%20lamp%20assembly%20clear%20lens%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig001img1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
  createHD120Product({
    id: 'MIG002',
    name: 'MIG002',
    description: 'FOG LAMP',
    subcategory: '램프',
    partNumber: '92201-5M000 L / 92202-5M000 R',
    fullDescription:
      '현대 HD120 MIG 시리즈에 호환되는 포그 램프입니다. 품번 92201-5M000 L / 92202-5M000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20fog%20lamp%20round%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig002main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20fog%20light%20round%20lens%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig002img1&orientation=portrait',
    ],
    colors: ['#FFFF00'],
  }),
  createHD120Product({
    id: 'MIG003',
    name: 'MIG003',
    description: 'TAIL LAMP',
    subcategory: '램프',
    partNumber: '92401-7A100 L / 92402-7A100 R',
    fullDescription:
      '현대 HD120 MIG 시리즈에 호환되는 테일 램프입니다. 품번 92401-7A100 L / 92402-7A100 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20tail%20lamp%20red%20rear%20light%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig003main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20tail%20light%20red%20rear%20lamp%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig003img1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createHD120Product({
    id: 'MIG003LED',
    name: 'MIG003LED',
    description: 'TAIL LAMP LED',
    subcategory: '램프',
    partNumber: '92401-7A100LED L / 92402-7A100LED R',
    fullDescription:
      '현대 HD120 MIG 시리즈에 호환되는 LED 테일 램프입니다. LED 타입으로 밝기와 내구성이 우수합니다.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20LED%20tail%20lamp%20red%20rear%20light%20bright%20LED%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig003ledmain&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20LED%20tail%20light%20red%20rear%20lamp%20bright%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig003ledimg1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createHD120Product({
    id: 'MIG004',
    name: 'MIG004',
    description: 'SIDE LAMP',
    subcategory: '램프',
    partNumber: '92503-5M000 L / 92504-5M000 R',
    fullDescription:
      '현대 HD120 MIG 시리즈에 호환되는 사이드 램프입니다. 품번 92503-5M000 L / 92504-5M000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20side%20marker%20lamp%20orange%20amber%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig004main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20side%20marker%20light%20orange%20amber%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig004img1&orientation=portrait',
    ],
    colors: ['#FFA500'],
  }),
  createHD120Product({
    id: 'MIG005',
    name: 'MIG005',
    description: 'GRILLE',
    subcategory: '외장',
    partNumber: '86510-5M010',
    fullDescription: '현대 HD120 MIG 시리즈에 호환되는 그릴입니다. 품번 86510-5M010.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20front%20grille%20black%20plastic%20mesh%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig005main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20front%20grille%20black%20mesh%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig005img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'MIG006',
    name: 'MIG006',
    description: 'BUMPER',
    subcategory: '외장',
    partNumber: '86311-5M000',
    fullDescription: '현대 HD120 MIG 시리즈에 호환되는 범퍼입니다. 품번 86311-5M000.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20front%20bumper%20gray%20metal%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig006main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20front%20bumper%20gray%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig006img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'MIG007',
    name: 'MIG007',
    description: 'FRONT PANEL',
    subcategory: '외장',
    partNumber: '82710-5M000 L / 82720-5M000 R',
    fullDescription:
      '현대 HD120 MIG 시리즈에 호환되는 프론트 패널입니다. 품번 82710-5M000 L / 82720-5M000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20front%20panel%20white%20metal%20body%20part%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig007main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20front%20panel%20white%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig007img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'MIG008',
    name: 'MIG008',
    description: 'GRILLE CHROME',
    subcategory: '외장',
    partNumber: '86313-5M100 / 86315/25-5M100',
    fullDescription:
      '현대 HD120 MIG 시리즈에 호환되는 크롬 그릴입니다. 품번 86313-5M100 / 86315/25-5M100.',
    compatibleVehicles: ['HD120', 'HD120 MIG'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20chrome%20front%20grille%20shiny%20silver%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=mig008main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20chrome%20grille%20shiny%20silver%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=mig008img1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
];

// ---------------------------------------------------------------
// VAN series (HD120 구형)
// ---------------------------------------------------------------
const vanProducts = [
  createHD120Product({
    id: 'VAN001',
    name: 'VAN001',
    description: 'HEAD LAMP',
    subcategory: '램프',
    partNumber: '92101-43810 L / 92102-43810 R',
    fullDescription:
      '현대 HD120 VAN 시리즈에 호환되는 헤드 램프입니다. 품번 92101-43810 L / 92102-43810 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20head%20lamp%20headlight%20rectangular%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van001main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20headlight%20rectangular%20clear%20lens%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van001img1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
  createHD120Product({
    id: 'VAN002',
    name: 'VAN002',
    description: 'CORNER LAMP',
    subcategory: '램프',
    partNumber: '92301-43810 L / 92302-43810 R',
    fullDescription:
      '현대 HD120 VAN 시리즈에 호환되는 코너 램프입니다. 품번 92301-43810 L / 92302-43810 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20corner%20lamp%20orange%20amber%20turn%20signal%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van002main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20corner%20lamp%20orange%20amber%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van002img1&orientation=portrait',
    ],
    colors: ['#FFA500'],
  }),
  createHD120Product({
    id: 'VAN003',
    name: 'VAN003',
    description: 'TAIL LAMP',
    subcategory: '램프',
    partNumber: '92401-43810 L / 92402-43810 R',
    fullDescription:
      '현대 HD120 VAN 시리즈에 호환되는 테일 램프입니다. 품번 92401-43810 L / 92402-43810 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20tail%20lamp%20red%20rear%20light%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van003main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20tail%20light%20red%20rear%20lamp%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van003img1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createHD120Product({
    id: 'VAN004',
    name: 'VAN004',
    description: 'FOG LAMP',
    subcategory: '램프',
    partNumber: '92201-43810 L / 92202-43810 R',
    fullDescription:
      '현대 HD120 VAN 시리즈에 호환되는 포그 램프입니다. 품번 92201-43810 L / 92202-43810 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '24V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20fog%20lamp%20round%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van004main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20fog%20light%20round%20lens%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van004img1&orientation=portrait',
    ],
    colors: ['#FFFF00'],
  }),
  createHD120Product({
    id: 'VAN005',
    name: 'VAN005',
    description: 'MIRROR',
    subcategory: '외장',
    partNumber: '87651/2-43810',
    fullDescription: '현대 HD120 VAN 시리즈에 호환되는 미러입니다. 품번 87651/2-43810.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20side%20mirror%20black%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van005main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20side%20mirror%20black%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van005img1&orientation=portrait',
    ],
    colors: ['#000000'],
  }),
  createHD120Product({
    id: 'VAN006',
    name: 'VAN006',
    description: 'BUMPER',
    subcategory: '외장',
    partNumber: '86511-43800',
    fullDescription: '현대 HD120 VAN 시리즈에 호환되는 범퍼입니다. 품번 86511-43800.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20front%20bumper%20gray%20metal%20wide%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van006main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20front%20bumper%20gray%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van006img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'VAN007',
    name: 'VAN007',
    description: 'BUMPER',
    subcategory: '외장',
    partNumber: '86511-43800',
    fullDescription: '현대 HD120 VAN 시리즈에 호환되는 범퍼 (타입 B)입니다. 품번 86511-43800.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20front%20bumper%20type%20B%20gray%20metal%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van007main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20front%20bumper%20type%20B%20gray%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van007img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'VAN008',
    name: 'VAN008',
    description: 'BUMPER',
    subcategory: '외장',
    partNumber: '86511-43800',
    fullDescription: '현대 HD120 VAN 시리즈에 호환되는 범퍼 (타입 C)입니다. 품번 86511-43800.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20front%20bumper%20type%20C%20gray%20metal%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van008main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20front%20bumper%20type%20C%20gray%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van008img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'VAN009',
    name: 'VAN009',
    description: 'BUMPER SUPPORT',
    subcategory: '외장',
    partNumber: '86520-43800',
    fullDescription: '현대 HD120 VAN 시리즈에 호환되는 범퍼 서포트입니다. 품번 86520-43800.',
    compatibleVehicles: ['HD120', 'HD120 VAN'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20VAN%20old%20model%20commercial%20truck%20bumper%20support%20bracket%20metal%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=van009main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=old%20model%20commercial%20truck%20bumper%20support%20bracket%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=van009img1&orientation=portrait',
    ],
  }),
];

// ---------------------------------------------------------------
// HDM series
// ---------------------------------------------------------------
const hdmProducts = [
  createHD120Product({
    id: 'HDM025',
    name: 'HDM025',
    description: 'SIDE SILL ASSY',
    subcategory: '외장',
    partNumber: '65411-6B001 / 65421-6B001',
    fullDescription:
      '현대 HD120에 호환되는 사이드 실 어셈블리입니다. 품번 65411-6B001 / 65421-6B001. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20side%20sill%20assembly%20metal%20body%20part%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=hdm025main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20side%20sill%20assembly%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=hdm025img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'HDM026',
    name: 'HDM026',
    description: 'SIDE STEP',
    subcategory: '외장',
    partNumber: '87716-68000 / 87726-6B000',
    fullDescription:
      '현대 HD120에 호환되는 사이드 스텝입니다. 품번 87716-68000 / 87726-6B000. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20side%20step%20metal%20footstep%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=hdm026main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20side%20step%20metal%20footstep%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=hdm026img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'HDM027',
    name: 'HDM027',
    description: 'SIDE STEP',
    subcategory: '외장',
    partNumber: '86932-6B000',
    fullDescription:
      '현대 HD120에 호환되는 사이드 스텝 (타입 B)입니다. 품번 86932-6B000.',
    compatibleVehicles: ['HD120'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20side%20step%20type%20B%20metal%20footstep%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=hdm027main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20side%20step%20type%20B%20metal%20footstep%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=hdm027img1&orientation=portrait',
    ],
  }),
  createHD120Product({
    id: 'HDM018',
    name: 'HDM018',
    description: 'DOOR',
    subcategory: '외장',
    partNumber: '75003-7C500 L / 75004-7C500 R',
    fullDescription:
      '현대 HD120에 호환되는 도어입니다. 품번 75003-7C500 L / 75004-7C500 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['HD120'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20HD120%20commercial%20truck%20door%20panel%20white%20metal%20body%20part%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=hdm018main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=commercial%20truck%20door%20panel%20white%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=hdm018img1&orientation=portrait',
    ],
  }),
];

// ---------------------------------------------------------------
// Export combined product list
// ---------------------------------------------------------------
export const hd120Products = [...migProducts, ...vanProducts, ...hdmProducts];
